// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-browsers',
    standalone: false,
    templateUrl: './browsers.component.html',
})
export class StatisticsVisitorsBrowsersComponent implements OnInit {
    updateDateRange = this.onUpdateDateRange.bind(this);

    domain: any;
    loading: boolean = false;
    chartType: string = 'bar-chart';
    pages: any[] = [];
    date: any;
    dateFormat = 'ddd, D. MMM YYYY';
    summary: any = {};
    chartLabels: any[] = [];
    chartData: any[] = [];
    barData: any[] = [];
    doughnutColors: string[] = ['#FF5879', '#FF9439', '#FEC64B', '#42B8B8', '#2F98E9'];
    barOverride: any[] = [];
    doughnutOptions: any = {};
    barOptions: any = {};
    exports: any[] = [];
    promise: any;
    page: any;
    pageSize: any;
    totalVisits: number = 0;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.loading = false;
        this.chartType = 'bar-chart';
        this.pages = [];
        this.date = this.dateRangeService.setRangeDates();
        this.summary = {};

        this.setupChart();
        this.onUpdateDateRange();
        this.getSummary();
        this.getPage();
    }

    setupChart () {
        this.chartLabels = [];
        this.chartData = [];
        this.barData = [];
        this.doughnutColors = ['#FF5879', '#FF9439', '#FEC64B', '#42B8B8', '#2F98E9'];
        this.barOverride = [
            {
                borderWidth: 0,
                borderColor: '#50a6fb',
                backgroundColor: '#50a6fb',
            },
        ];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                intersect: false,
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
        this.barOptions = {
            legend: {
                display: false,
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            callback: (value: any) => {
                                return this.pipeService.get('monNumber')(value, '0,0');
                            },
                            min: 0,
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                    },
                ],
            },
            tooltips: {
                intersect: false,
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        return (
                            this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]) +
                            ' ' +
                            this.translateService.getString('Visits')
                        );
                    },
                },
            },
        };
    }

    getPage () {
        const params = {
            limit: this.pageSize || 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };
        this.exports = [
            {
                tooltip: this.translateService.getString('Export visitors browsers'),
                name: this.translateService.getString('Visitors browsers export'),
                data: {
                    category: 'visitors_browsers',
                    category_ref: this.date.startDate?.format('YYYY-MM-DD') + ',' + this.date.endDate?.format('YYYY-MM-DD'),
                },
            },
        ];
        let others = 0;
        this.loading = true;
        this.promise = this.statsRepoService.getBrowsers(params)
            .then((data: any) => {
                this.pages = data;
                this.totalVisits = data.reduce((total: number, page: any) => {
                    return total + parseInt(page.visits);
                }, 0);
                this.chartLabels = [];
                this.chartData = [];
                for (let i = 0; i < this.pages.length; i++) {
                    if (i < 5) {
                        this.chartLabels.push(this.pages[i].label);
                        this.chartData.push(this.pages[i].visits);
                    } else {
                        others += parseInt(this.pages[i].visits);
                    }
                }
                if (this.pages.length > 5) {
                    this.chartLabels.push(this.translateService.getString('Others'));
                    this.chartData.push(others);
                }

                this.barData = [this.chartData];
            })
            .finally(() => {
                this.loading = false;
            });
    }

    onUpdateDateRange () {
        if (this.date.startDate || this.date.endDate) {
            this.paramService.setParams({
                from: moment(this.date.startDate),
                to: moment(this.date.endDate),
            });
            this.getPage();
        }
    }

    getSummary () {
        const params = {
            domainId: this.stateService.params.domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
            type: 'total',
        };
        this.statsRepoService.getSummary(params)
            .then((data: any) => {
                this.summary = data;
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
